import React from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { PrimeReactProvider } from 'primereact/api';

import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";

import './assets/demo/flags/flags.css';
import './assets/demo/Demos.css';
import './assets/layout/layout.css';
import './GlobalOverrides.css';


import Menu from './pages/Menu';
import Login from './pages/Login';
// import Register from './pages/Register'; // Deshabilitado para admins temporamente
import Usuario from './pages/Usuario';
import Permisos from './pages/Permisos';
import Perfil from './pages/Perfil';
import Dashboard from './pages/Dashboard';
// import Temas from './pages/Temas';

// Ventas Pro Pages
import POS from './pages/ventas/POS';
import Productos from './pages/inventario/Productos';
import Categorias from './pages/inventario/Categorias';
import Clientes from './pages/operaciones/Clientes';
import Kardex from './pages/inventario/Kardex';
import Gastos from './pages/operaciones/Gastos';
import Empresa from './pages/configuracion/Empresa';
import ApiSunat from './pages/configuracion/ApiSunat';
import Sucursales from './pages/configuracion/Sucursales';
import Reportes from './pages/reportes/Reportes';
import Cajas from './pages/operaciones/Cajas';
import Devoluciones from './pages/operaciones/Devoluciones';
import Almacenes from './pages/inventario/Almacenes';
import TipoCambio from './pages/configuracion/TipoCambio';
import Auditoria from './pages/reportes/Auditoria';

// E-Commerce Pages
import EcommerceLayout from './ecommerce/EcommerceLayout';
import EcommerceHome from './ecommerce/pages/EcommerceHome';
import ProductDetail from './ecommerce/pages/ProductDetail';
import ProductList from './ecommerce/pages/ProductList';
import Checkout from './ecommerce/pages/Checkout';
import ClientePerfil from './ecommerce/pages/ClientePerfil';
import MisCompras from './ecommerce/pages/MisCompras';
import ClienteConfiguracion from './ecommerce/pages/ClienteConfiguracion';

function App() {
  return (
    <PrimeReactProvider>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <AuthProvider>
                    <Routes>
            {/* E-Commerce (Público) */}
            <Route path="/tienda" element={<EcommerceLayout />}>
              <Route index element={<EcommerceHome />} />
              <Route path="producto/:id" element={<ProductDetail />} />
              <Route path="catalogo" element={<ProductList />} />
              <Route path="checkout" element={<Checkout />} />
              <Route path="perfil" element={<ClientePerfil />} />
              <Route path="mis-compras" element={<MisCompras />} />
              <Route path="configuracion" element={<ClienteConfiguracion />} />
            </Route>

            {/* Admin / POS */}
            <Route exact path="/" element={<Menu />} >
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route exact path="/usuario" element={<Usuario />} />
              <Route exact path="/permisos" element={<Permisos />} />
              <Route exact path="/perfil" element={<Perfil />} />
              <Route exact path="/dashboard" element={<Dashboard />} />
              {/* Página de Temas deshabilitada por alcance funcional del sistema */}
              {/* <Route exact path="/temas" element={<Temas />} /> */}

              {/* Ventas Pro Rutas */}
              <Route exact path="/pos" element={<POS />} />
              <Route exact path="/cajas" element={<Cajas />} />
              <Route exact path="/devoluciones" element={<Devoluciones />} />
              <Route exact path="/productos" element={<Productos />} />
              <Route exact path="/almacenes" element={<Almacenes />} />
              <Route exact path="/categorias" element={<Categorias />} />
              <Route exact path="/clientes" element={<Clientes />} />
              <Route exact path="/kardex" element={<Kardex />} />
              <Route exact path="/gastos" element={<Gastos />} />
              <Route exact path="/empresa" element={<Empresa />} />
              <Route exact path="/api-sunat" element={<ApiSunat />} />
              <Route exact path="/sucursales" element={<Sucursales />} />
              <Route exact path="/tipo-cambio" element={<TipoCambio />} />
              <Route exact path="/reportes" element={<Reportes />} />
              <Route exact path="/auditoria" element={<Auditoria />} />
                          </Route>
            <Route exact path="/admin/login" element={<Login />} />
            {/* <Route exact path="/admin/register" element={<Register />} /> Deshabilitado por un admin */}
          </Routes>
                  </AuthProvider>
      </BrowserRouter>
    </PrimeReactProvider>
  );
}

export default App;

